const localeEn = {
  // Error view
  UDE_BUNDLES_ERROR: 'An error occurred while fetching your certifications',
  // Bundle card
  UDE_BUNDLE_COMPLETED: 'Certification completed',
};
export default localeEn;
